// The marketing page is on another host and sends no CORS headers, so this cannot go through axios:
// a no-cors request gives an opaque response, and only rejects when the host cannot be reached at all.
export const checkMarketingPage = url => fetch(url, { method: 'HEAD', mode: 'no-cors' })

export default {}
